// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"0e7cf9b0","703":"83175350"}[chunkId] + ".chunk.js";
};